import * as Types from '../constants/actionTypes';
const initState = {
    programRecursiveRequest: [],
    recursiveRequestError: '',
}
export default (state = initState, action) => {
    switch (action.type) {
        case Types.PROGRAM_RECURSIVE_REQUEST: {
            return {
                ...state,
                programRecursiveRequest: action.payload,
            }
        }
        case Types.RECURSIVE_REQUEST_ERROR: {
            return {
                ...state,
                recursiveRequestError: action.error,
            }
        }
        default:
            return state;
    }
};